var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediumRareRoundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6048_26241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 21.9925V39.107C0.5 50.9478 10.0522 60.5995 21.9925 60.5995H39.107C50.9478 60.5995 60.5995 51.0473 60.5995 39.107V21.9925C60.5995 10.1517 51.0473 0.5 39.107 0.5H21.9925C10.1517 0.5 0.5 10.1517 0.5 21.9925ZM21.9925 9.05721H39.107C46.1716 9.05721 51.9428 14.8284 51.9428 21.893V39.0075C51.9428 46.0721 46.1716 51.8433 39.107 51.8433H21.9925C14.9279 51.8433 9.15671 46.0721 9.15671 39.0075V21.9925C9.15671 14.8284 14.9279 9.05721 21.9925 9.05721Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.272 17.7148H34.8293C39.6054 17.7148 43.3865 21.5954 43.3865 26.2721V34.8293C43.3865 39.6054 39.5059 43.3865 34.8293 43.3865H26.272C21.4959 43.3865 17.7148 39.5059 17.7148 34.8293V26.2721C17.7148 21.4959 21.4959 17.7148 26.272 17.7148Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6048_26241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumRareRoundIcon);
export default __webpack_public_path__ + "static/media/medium-rare-round-icon.ffaae44567190911594ca05cd2be637e.svg";
export { ForwardRef as ReactComponent };